import React from "react";

import { Button, Popover, Stack, StackProps, Typography } from "@mui/material";
import ReactHtmlParser from "html-react-parser";

const containerStyle: StackProps["sx"] = {
  outline: "none",
  bgcolor: "white",
  minWidth: "550px",
  maxWidth: "600px",
  p: "20px",
  gap: "20px",
  borderRadius: "8px",
  boxShadow:
    "0px 2px 4px -1px rgba(0, 0, 0, 0.20), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)"
};

interface Props {
  note: string;
  onClose: () => void;
  anchorEl: HTMLElement | null;
  onRemoveAIConstruction: () => void;
}

export const NoteHintPopover: React.FC<Props> = ({ note, onClose, anchorEl, onRemoveAIConstruction }) => {
  return (
    <Popover
      open={!!anchorEl}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left"
      }}
      sx={{
        "& .MuiPopover-paper": {
          marginTop: "10px",
          marginLeft: "-40px"
        }
      }}
    >
      <Stack sx={containerStyle}>
        <Stack
          direction="row"
          sx={{ justifyContent: "space-between", alignItems: "center", pb: "8px", borderBottom: "1px solid #DBE8F5" }}
        >
          <Typography>AI Construction</Typography>
        </Stack>
        <Stack flexDirection="column" justifyContent="space-between" alignItems="center" minHeight="100px" gap="20px">
          <Typography alignSelf="flex-start" fontSize="16px" color="#0A3243">
            {ReactHtmlParser(note)}
          </Typography>
          <Stack flexDirection="row" justifyContent="flex-end" alignItems="center" gap="10px" width="100%">
            <Button
              onClick={() => {
                onRemoveAIConstruction();
                onClose();
              }}
              variant="outlined"
            >
              Remove AI construction
            </Button>
            <Button onClick={onClose} variant="contained" sx={{ backgroundColor: "#071F35" }}>
              OK
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Popover>
  );
};
